import { PropsWithChildren, ReactNode } from "react";

import { Stack } from "@mui/material";

const NAVIGATION_COLUMN_WIDTH = 320;

interface Props extends PropsWithChildren {
  navigation?: ReactNode;
  navigationFooter?: ReactNode;
}

// The two-column frame of a client-file area, shared by both apps: the section navigation in a
// fixed-width left column (with an optional footer slot below it, e.g. the internal app's status
// widget) and the active section on the right, on the fsw.blue-5 backdrop that frames the white
// content cards. Without navigation and footer the left column is omitted and the content spans the
// full width (the portal's flat areas); pass an empty navigation (<></>) to keep the column reserved.
export function ClientTabFrame({ navigation, navigationFooter, children }: Props) {
  const hasNavigationColumn = navigation != null || navigationFooter != null;

  return (
    <Stack direction={"row"} gap={3} sx={{ flexGrow: 1, overflow: "hidden" }}>
      {hasNavigationColumn && (
        <Stack gap={2} sx={{ flex: `0 0 ${NAVIGATION_COLUMN_WIDTH}px`, maxHeight: "100%", minWidth: 0, pb: 1 }}>
          <Stack overflow={"hidden"} flex={1}>
            {navigation}
          </Stack>
          {navigationFooter}
        </Stack>
      )}
      <Stack
        bgcolor={(theme) => theme.palette.fsw["blue-5"]}
        sx={{ flex: 1, minWidth: 0, maxHeight: "100%", gap: 1, p: 1 }}
      >
        {children}
      </Stack>
    </Stack>
  );
}
